import * as Sentry from '@sentry/react'
import { withAmplitude } from './analytics'

export const identifyUser = (user, companyName) => {
  // Not every account has an email (client-company logins are often
  // username + password only) -- username is the one field the backend
  // always requires, so it is the reliable identity key. companyName is
  // a separate property (not the identity itself), so several people at
  // the same company still show up as distinct users, filterable by
  // company on top.
  const identityKey = user?.email || user?.username
  if (!identityKey) return

  withAmplitude((amplitude) => {
    amplitude.setUserId(identityKey)
    if (companyName) {
      const identity = new amplitude.Identify().set('company', companyName)
      amplitude.identify(identity)
    }
  })

  Sentry.setUser({
    id: String(user.id),
    email: user.email || undefined,
    username: [user.first_name, user.last_name].filter(Boolean).join(' ') || user.username,
  })
  if (companyName) Sentry.setTag('company', companyName)
}

export const resetIdentity = () => {
  withAmplitude((amplitude) => amplitude.reset())
  Sentry.setUser(null)
  Sentry.setTag('company', undefined)
}
